import { render, staticRenderFns } from "./LinkCardVertical.vue?vue&type=template&id=08febcb7"
import script from "./LinkCardVertical.vue?vue&type=script&lang=js"
export * from "./LinkCardVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports